import React, { useMemo } from 'react';

// DEPENDENCIES
import * as yup from 'yup';

// LOCAL COMPONENTS
import Control from '../Control';

// MAIN COMPONENT
const Number = ({
  min,
  minErrorMessage = '',
  max,
  maxErrorMessage = '',
  ...props
}) => {

  // MEMOS
  const validationSchema = useMemo(
    () => yup.number()
      .transform(value => {
        const float = parseFloat(value);
        if (isNaN(float) && float !== undefined && float !== null) {
          throw new yup.ValidationError('Must be a number.', value, 'typeError');
        }
        return float;
      })
      .nullable()
      .required("Required")
      .when('$min', (_value, schema) =>
        min !== undefined && !isNaN(min)
          ? schema.min(min, minErrorMessage || `Must be no less than ${min}.`)
          : schema,
      )
      .when('$max', (_value, schema) =>
        max !== undefined && !isNaN(max)
          ? schema.max(max, maxErrorMessage || `Must be no more than ${max}.`)
          : schema,
      ), [min, max, minErrorMessage, maxErrorMessage])

  // RENDER
  return (
    <Control
      {...props}
      type="number"
      validationSchema={validationSchema}
    />
  )
}

// EXPORT
export default Number;
